import { ChangeEvent } from 'react';

// Parsing phone number to xxx-xxx-xxxx format
export const phoneInput = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string): string => {
    let value = typeof event === 'string' ? event : event.target.value;
    if (!value) return '';

    value = value.replace(/\D/g, '');
    if (value.length > 10) {
        value = value.substring(0, 10);
    }
    let formattedValue = '';

    for (let i = 0; i < value.length; i++) {
        if (i === 3 || i === 6) {
            formattedValue += '-';
        }
        formattedValue += value[i];
    }

    return formattedValue;
};
